import { __assign } from "tslib";
import React from 'react';
import Button from '../Button';
import { useLangData } from '../ConfigProvider';
import { concat } from '../utils';
import { TipIcon } from '../icons';
export default function Inner(_a) {
    var icon = _a.icon, title = _a.title, content = _a.content, prefix = _a.prefix, buttons = _a.buttons, close = _a.close;
    var iconPrefix = concat(prefix, 'icon');
    var mainPrefix = concat(prefix, 'main');
    var titlePrefix = concat(mainPrefix, 'title');
    var contentPrefix = concat(mainPrefix, 'content');
    var btnsPrefix = concat(mainPrefix, 'btns');
    icon = icon === true ? React.createElement(TipIcon, null) : icon;
    return (React.createElement(React.Fragment, null,
        icon && React.createElement("div", { className: iconPrefix }, icon),
        React.createElement("div", { className: mainPrefix },
            title && React.createElement("div", { className: titlePrefix }, title),
            React.createElement("div", { className: contentPrefix }, content),
            buttons && React.createElement(Buttons, __assign({ prefix: btnsPrefix, close: close }, (buttons === true ? {} : buttons))))));
}
function Buttons(props) {
    var langData = useLangData('modal');
    var prefix = props.prefix, onCancel = props.onCancel, onOk = props.onOk, cancelButtonProps = props.cancelButtonProps, okButtonProps = props.okButtonProps, _a = props.cancelText, cancelText = _a === void 0 ? langData.cancelText : _a, _b = props.okText, okText = _b === void 0 ? langData.okText : _b, close = props.close;
    function handleCancel(event) {
        close();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(event);
    }
    function handleOk(event) {
        close();
        onOk === null || onOk === void 0 ? void 0 : onOk(event);
    }
    return (React.createElement("div", { className: prefix },
        React.createElement(Button, __assign({ type: "primary", size: "small", onClick: handleOk }, okButtonProps), okText),
        React.createElement(Button, __assign({ size: "small", onClick: handleCancel }, cancelButtonProps), cancelText)));
}
//# sourceMappingURL=Inner.js.map